<script>
  function readDraft(key) {
    try {
      return localStorage.getItem(key) || "";
    } catch {
      return "";
    }
  }

  function writeDraft(key, value) {
    try {
      localStorage.setItem(key, value || "");
    } catch {
      // localStorage unavailable (private browsing, disabled storage, etc.) - not fatal
    }
  }

  let { filteredData, http, toastr, onCancel } = $props();

  let sender = $state(readDraft("sender"));
  let sendername = $state(readDraft("sendername"));
  let subject = $state(readDraft("subject"));
  let contents = $state(readDraft("contents"));
  let submitted = $state(false);
  let sentItems = $state(0);
  let isSending = $state(false);
  let sendErrors = $state([]);

  const totalItems = filteredData.length;

  function isValid() {
    return !!sender && !!sendername && !!subject && !!contents;
  }

  function processResponse(response) {
    if (response !== undefined) {
      const results = response.data.results;
      sentItems += results.length;
      for (const result of results) {
        if (!result.success) {
          sendErrors = [
            ...sendErrors,
            { idcz: result.idcz, email: result.email, message: result.error_message },
          ];
        }
      }
    }
  }

  function startSend(valid) {
    submitted = true;
    if (!valid) return;
    sendErrors = [];
    sentItems = 0;
    isSending = true;
    const batchSize = 10;
    const infoToSend = {
      sender,
      sendername,
      subject,
      contents,
    };
    let chain = Promise.resolve();
    const indices = [];
    let i = 0;
    while (i < filteredData.length) {
      indices.push(i);
      chain = chain.then(
        (response) => {
          processResponse(response);
          const restoredI = indices.shift();
          return http.post("/api/mailer.php", {
            ...infoToSend,
            records: filteredData.slice(restoredI, restoredI + batchSize),
          });
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
      i += batchSize;
    }
    chain.then(
      (response) => {
        processResponse(response);
        isSending = false;
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  }

  function cancel() {
    writeDraft("sender", sender);
    writeDraft("sendername", sendername);
    writeDraft("subject", subject);
    writeDraft("contents", contents);
    onCancel();
  }
</script>

<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel">Wysłanie poczty do wyselekcjonowanych osób</h4>
</div>
<div class="modal-body">
  <div class="panel panel-default">
      <div class="panel-body">
            <form name="theForm" class="form" role="form">
                <div class="form-group">
                     Nadawca e-maila:
                     <div><small class="text-muted">Podaj swoje imię i nazwisko oraz nazwę użytkownika adresu e-mail w domenie miastojestnasze.org (bez @). Na ten adres bedą przychodzić odpowiedzi.</small></div>
                     <div class="row">
                     <div class="col-sm-5">
                         <input type="text" class="form-control input-sm" placeholder="imie i nazwisko" bind:value={sendername} name="nadawca_nazwa" size="27" required>
                     </div>
                     <div class="col-sm-7">
                         <div class="input-group">
                             <span class="input-group-addon"><i class="far fa-address-card" aria-hidden="true"></i></span>
                             <input type="text" class="form-control input-sm" placeholder="identyfikator" bind:value={sender} name="nadawca" size="25" required>
                             <span class="input-group-addon">@miastojestnasze.org</span>
                         </div>
                     </div>
                     </div>
                     {#if submitted && (!sender || !sendername)}<small style="color:red">Trzeba wpisać nadawcę</small>{/if}
                </div>
                <div class="form-group">
                     Tytuł e-maila:
                     <div class="input-group">
                         <span class="input-group-addon"><i class="fas fa-envelope-open" aria-hidden="true"></i></span>
                         <input type="text" class="form-control input-sm" placeholder="tytuł e-maila" bind:value={subject} name="tytul" size="40" required>
                     </div>
                     {#if submitted && !subject}<small style="color:red">Trzeba wpisać tytuł</small>{/if}
                </div>
                <div class="form-group">
                     Treść:
                     <div><small class="text-muted">Możesz używać specjalnych pól: %imie%, %nazwisko%, %saldo_pocz%, %saldo%, %w1%..%w12% itd.</small></div>
                     <div class="input-group">
                         <span class="input-group-addon"><i class="far fa-envelope" aria-hidden="true"></i></span>
                         <textarea class="form-control input-sm" rows="7" bind:value={contents} name="tresc" required></textarea>
                     </div>
                     {#if submitted && !contents}<small style="color:red">Trzeba wpisać treść e-maila</small>{/if}
                </div>
                Postęp wysyłania:
                <div><small class="text-muted">Poczta zostanie wysłana do osób wyselekcjonowanych w widoku <i>Składki</i>. Jeśli chcesz zmienić tę listę, naciśnij <i>Zamknij</i>, zmień tekst w polu wyszukiwania i wywołaj to okienko ponownie.</small></div>
                <div class="panel panel-default form-group form-inline">
                    <div class="panel-body">
                    <div class="btn-toolbar pull-left form-inline">
                        <button type="button" class="btn btn-sm">{sentItems}/{totalItems}&nbsp;&nbsp;{#if isSending}<span class="fas fa-spinner fa-spin animate-fix"></span>{/if}</button>
                    </div>
                    <div class="btn-toolbar pull-right form-inline">
                        <button type="button" class="btn btn-warning btn-sm pull-right" onclick={() => startSend()} disabled={!isSending}>
                        <i class="fas fa-pause" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-success btn-sm pull-right" onclick={() => startSend(isValid())} disabled={isSending}>
                        <i class="fas fa-play" aria-hidden="true"></i>&nbsp;&nbsp;Rozpocznij wysyłanie</button>

                    </div>
                    </div>
                </div>

                {#if sendErrors.length > 0}
                <div>
                Błędy przy wysyłaniu ({sendErrors.length}):
                <small style="overflow-y: scroll; height: 100px; display: block"><small>
                <table class="table table-condensed table-hover table-striped">
    			<thead class="thead-default">
                    <tr>
                        <td>Lp.</td>
        				<td>E-mail</td>
                        <td>Błąd</td>
                    </tr>
                </thead>
                <tbody>
                    {#each sendErrors as error}
                    <tr>
                        <td>{error.idcz}</td>
                        <td class="danger">{error.email}</td>
                        <td>{error.message}</td>
                    </tr>
                    {/each}
                </tbody>
                </table>
                </small></small>
                </div>
                {/if}

            </form>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-default" onclick={cancel}>Zamknij</button>
</div>
